import { render } from "./GameRecord.vue?vue&type=template&id=1c0a0dd2&scoped=true"
import script from "./GameRecord.vue?vue&type=script&lang=js"
export * from "./GameRecord.vue?vue&type=script&lang=js"

import "./GameRecord.vue?vue&type=style&index=0&id=1c0a0dd2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src996785304/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0a0dd2"]])

export default __exports__